import {
  DirectionsCarOutlined,
  Fence,
  LocalParking,
  StraightOutlined,
} from "@mui/icons-material";

export class AlertPoliciesUtils {
  static getRuleIcon(rule) {
    switch (rule) {
      case "TRAVEL_TIME_THRESHOLD_EXCEEDED":
        return <StraightOutlined style={{ color: "#e57300" }} />;
      case "TRAFFIC_CONGESTION":
        return (
          <DirectionsCarOutlined
            style={{ color: "#e57300", paddingRight: "2px" }}
          />
        );
      case "AUTOMATIC_SYSTEMS_GATE_MODE_CHANGED":
        return <Fence style={{ color: "#008de5" }} />;
      case "PARKING_FILLED":
        return <LocalParking style={{ color: "#e57300" }} />;
      case "AUTOMATIC_SYSTEMS_GATE_COUNTER_INCREMENTED":
        return <Fence style={{ color: "#e5c600ff" }} />;
      case "AUTOMATIC_SYSTEMS_GATE_DISCONNECTED":
        return <Fence style={{ color: "#ee1000" }} />;
      default:
        return null;
    }
  }

  static getOutputTypes() {
    return ["BO", "BO_TOAST"];
  }
}
